import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateEmployeeCheckWebhook = (axios: IAxiosInstance) => {
  return async ({
    employeeCheckWebhook,
    userType,
    usePrimary,
    isTestWebhookType,
  }: ISchema["#/definitions/IUpdateEmployeeCheckWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateEmployeeCheckWebhookResponse"]
    >(`/api/updateEmployeeCheckWebhook${getUsePrimaryUrlParams(usePrimary)}`, {
      employee_check_webhook: employeeCheckWebhook,
      user_type: userType,
      is_test_webhook_type: isTestWebhookType,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
